module.exports = __webpack_public_path__ + "static/img/200131.47bbf884.png";